// extracted by mini-css-extract-plugin
export var activityContainer = "_l8-0";
export var typingIndicatorContainer = "_l8-1";
export var typingIndicatorDot = "_l8-2";
export var wave = "_l8-3";